/**
 * Lead popup — "Free Payment Health Check", the scroll/time-triggered
 * fallback conversion path (components/LeadPopup.jsx owns the trigger and
 * popup_shown / popup_dismissed analytics).
 */
import { email, fullName, turnoverBand } from "./common";

const leadPopup = {
  id: "lead_popup_health_check",
  label: "Lead popup: Free Payment Health Check",
  crm: { layout: "Standard", leadSource: "Website Lead Popup", tags: [] },
  fields: [
    fullName,
    { ...email, label: "Your email" },
    { ...turnoverBand, type: "radio", label: "Monthly card turnover (optional)" },
  ],
  submitLabel: "Get my free health check",
  consent: { variant: "condensed" },
  success: {
    title: "You're on the list",
    body: "We'll send your free Payment Health Check shortly.",
  },
  summary: () => "Free Payment Health Check (lead popup)",
};

export default leadPopup;
